/**
** JAVASCRIPTS
** Name: Didomi
********************************************************************************/

const YOUTUBE_VENDOR_ID = 'youtube';

const playVideoAndHideOverlay = (overlay) => {
  const iframe = overlay.querySelector("iframe[data-src]");
  if (!iframe) return;

  iframe.setAttribute("src", iframe.getAttribute("data-src"));
  iframe.removeAttribute("data-src");

  const control = overlay.querySelector(".js-cookies-control");
  if (control) control.style.display = "none";
};

const setPositiveConsentStatusForVendor = (vendorId) => {
  const vendor = Didomi.getVendorById(vendorId);
  if (!vendor) return;

  const transaction = Didomi.openCurrentUserStatusTransaction();
  transaction.enableVendor(vendor.didomiId);
  transaction.enablePurposes(vendor.purposeIds);
  transaction.commit();
};

const isYoutubeAllowed = () => {
  try {
    const status = Didomi.getCurrentUserStatus();

    const vendor = status?.vendors?.[YOUTUBE_VENDOR_ID];
    if (vendor?.enabled === true || vendor?.consent === true) return true;

    if (Didomi.shouldUserStatusBeCollected() === false) {
      const purposes = Object.values(status?.purposes || {});
      return purposes.length > 0 && purposes.some(p => p.enabled === true);
    }

    return false;
  } catch (e) {
    return false;
  }
};

const onYoutubeConsentGranted = () => {
  document
    .querySelectorAll('.js-cookies-placeholder[data-cookies-vendor="youtube"]')
    .forEach(playVideoAndHideOverlay);
};

const setupDidomi = (Didomi) => {
  try {
    Didomi.getObservableOnUserConsentStatusForVendor(YOUTUBE_VENDOR_ID).subscribe(() => {
      if (isYoutubeAllowed()) {
        onYoutubeConsentGranted();
      }
    });
  } catch (e) {}

  document.querySelectorAll(".js-cookies-control").forEach((button) => {
    button.addEventListener("click", () => {
      setPositiveConsentStatusForVendor(button.dataset.cookiesVendor);
    });
  });
};

document.addEventListener('DOMContentLoaded', () => {
  const tryInit = () => {
    if (window.Didomi) {
      setupDidomi(window.Didomi);
    } else {
      setTimeout(tryInit, 100);
    }
  };
  tryInit();
});
